import { createReducer } from '@reduxjs/toolkit';
import { authActions } from './actions';
import { AuthState } from './types';

const initialState: AuthState = {
  user: undefined,
  issuedAt: undefined,
  authSucceeded: undefined,
};

export const authReducer = createReducer(initialState, builder =>
  builder
    .addCase(authActions.logOut, () => {
      return { ...initialState };
    })
    .addCase(authActions.fetchUserStart, (state, action) => {
      state.authSucceeded = undefined;
    })
    .addCase(authActions.fetchUserSuccess, (state, action) => {
      state.user = action.payload.user;
      state.authSucceeded = true;
    })
    .addCase(authActions.updateTokenIssuedAt, (state, action) => {
      state.issuedAt = action.payload.issuedAt;
    })
    .addCase(authActions.updateTosAcceptedAtSuccess, (state, action) => {
      if (state.user) {
        state.user.tosAcceptedAt = action.payload.tosAcceptedAt;
        state.authSucceeded = true;
      } else {
        state.authSucceeded = false;
      }
    })
    .addCase(authActions.fetchUserFailure, (state, action) => {
      state.authSucceeded = false;
    })
    .addDefaultCase(state => state),
);
